import * as React from 'react'
import MUIAppBar from '@mui/material/AppBar'

const AppBar = (props) => <MUIAppBar {...props} />

export default AppBar
